export interface ISensitiveFieldInfo<T extends object> {
  field: keyof T
}

// In our VERY BEST masking implementation we will send this value in place of data a user does not have access to see.
// Will this work in all situations? No. Could be break the frontend? Yes. What about data coming back? Probably filtered somewhere, hopefully.
export const MASKED_DATA_VALUE = '******'

// This is what the user will see when a value is masked.
// What about different values per type or showing some of the data? That could be nice for a non-BETA implementation.
export const USER_FACING_MASK_VALUE = '*****'
